/**
 * Created by Astha on 12/27/2017.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Popover from '../Popover';
import $ from 'jquery';
import Div from './elements/Div';
import t from '../i18n/I18n';

export default class EditProfileImagePopover extends React.Component {
  static propTypes = {
    uploadPic: PropTypes.func.isRequired,
    removePic: PropTypes.func,
    showRemovePic: PropTypes.bool,
    showPopover: PropTypes.bool.isRequired,
    editRef :  PropTypes.oneOfType([
                    PropTypes.func, 
                    PropTypes.shape({ current: PropTypes.any })
                ])
  };

  constructor(props) {
    super(props);
    this.state = {
      showPopover: false,
      showRemovePic: this.props.showRemovePic
    };
  }

  render() {
    const { uploadPic, editRef,removePic, showRemovePic, showPopover } = this.props;
    const styles = getStyle();
    const position = {
      left: '50%',
      top: 0
    }
    if(editRef.current !== null) position.top = editRef.current.getBoundingClientRect().top + 20;

    return (
      <div
        onClick={(event) => {
          event.stopPropagation();
          this.setState({ showPopover: !this.state.showPopover });
        }}>
        <Div
          className="fa-pencil-square fa-2x"
          ref="icon"
          title={t('EDIT_PROFILE_IMAGE')}
          onClick={() => this.setState({ showPopover: !this.state.showPopover })}
          style={{ ...styles.editIcon, color: 'grey' }}
        />
        {this.state.showPopover ? (
          <Popover onClose={() => this.setState({ showPopover: false })} top={position.top} left={position.left} style={{ float: 'right', align: 'center' }}>
            <div style={{ padding: '10px 10px 0 10px', cursor: 'default' }}>
              <div onClick={uploadPic} style={styles.option}>
                {t('EDIT_PROFILE.UPLOAD_IMAGE')}
              </div>
              {showRemovePic ? (
                <div onClick={removePic} style={styles.option}>
                  {t('EDIT_PROFILE.REMOVE_IMAGE')}
                </div>
              ) : null}
            </div>
          </Popover>
        ) : null}
      </div>
    );
  }
}

function getStyle() {
  return {
    editIcon: {
      fontFamily: 'fontAwesome'
    },
    option: {
      cursor: 'pointer',
      color: 'var(--primary-font-color)',
      fontSize: '14px',
      marginBottom: '10px',
      textAlign: 'left'
    }
  };
}
// const styles = {
//   editIcon: {
//     fontFamily: 'fontAwesome'
//   },
//   option: {
//     cursor: 'pointer',
//     color: '#7A7A7A',
//     fontSize: '14px',
//     marginBottom: '10px',
//     textAlign: 'left'
//   }
// };
